module.exports = __webpack_public_path__ + "assets/49be469c1c2ba705bae2fb95364a3c4a.eot";